export class ValidateInvitations {
  constructor(
    public usernames: string[],
    public emails: string[]
  ) {}
}
